import axios from 'axios';

import clientHTTP from '../helpers/http-client';
import {
  GET_VIACEP_BY_CEP,
  SELLER_TAGS_URL,
  UNLEASH_EXPERIMENT_URL,
  URL_COMPANY_INFO,
  URL_INTEGRATORS_LIST,
  URL_LIABLE_PARTNER,
  URL_LOGISTIC_ADDRESS,
  URL_SUBSCRIPTION_PLAN_OPTIONS,
  URL_SUBSCRIPTION_PLAN_V2_CHOICE,
} from '../utils/api-urls';

const axiosFreeCorsInstance = axios.create({
  timeout: 15000,
});

const Api = {
  postLogisticAddress: async (values) => {
    const response = await clientHTTP.post(URL_LOGISTIC_ADDRESS, values);
    return response.data;
  },
  postCompanyInformation: async (values) => {
    const response = await clientHTTP.post(URL_COMPANY_INFO, values);
    return response.data;
  },
  postLiablePartner: async (values) => {
    const response = await clientHTTP.post(URL_LIABLE_PARTNER, values);
    return response.data;
  },
  getSellerTags: async () => {
    const response = await clientHTTP.get(SELLER_TAGS_URL);
    return response.data;
  },
  getViaCEPAddressByCep: async (cep = '') => {
    const response = await axiosFreeCorsInstance.get(GET_VIACEP_BY_CEP, {
      params: {
        cep,
      },
    });
    return response.data;
  },
  getPlanListAndRules: async () => {
    const response = await clientHTTP.get(URL_SUBSCRIPTION_PLAN_V2_CHOICE);
    return response.data;
  },
  getPlanOptions: async () => {
    const response = await clientHTTP.get(URL_SUBSCRIPTION_PLAN_OPTIONS);
    return response.data;
  },
  getIntegratorsList: async () => {
    const response = await clientHTTP.get(URL_INTEGRATORS_LIST);
    return response.data;
  },
  getUnleashExperiment: async (tagName, leadId) => {
    const unleashContext = {
      userId: leadId,
    };

    const response = await clientHTTP.get(UNLEASH_EXPERIMENT_URL(tagName), {
      headers: {
        unleash_context: JSON.stringify(unleashContext),
      },
    });
    return response.data;
  },
};

export default Api;
